import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Card,
    CardContent,
    CardMedia,
    CircularProgress,
    List,
    ListItem,
    Grid,
} from "@mui/material";

function B2BMobileApps() {
    const [b2b, setB2b] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/enterpriseMobility/b2b_mobileApps.txt",
        }).then((res) => {
            setB2b(res.data);
            setLoading(false);
        });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                B2B Mobile Apps Development
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <Grid container spacing={4} alignItems="flex-start">

                    {/* Content Section */}
                    <Grid item xs={12} md={7}>
                        {b2b &&
                            b2b.map((item, index) => (
                                <Box key={index} mb={3}>
                                    {typeof item === "string" ? (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                mb: 2,
                                                textAlign: "justify",
                                                fontSize: "18px",
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    ) : Array.isArray(item) ? (
                                        <List sx={{ pl: 3 }}>
                                            {item.map((subItem, subIndex) => (
                                                <ListItem
                                                    key={subIndex}
                                                    sx={{
                                                        display: "list-item",
                                                        listStyleType: "disc",
                                                        pl: 1,
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {subItem}
                                                </ListItem>
                                            ))}
                                        </List>
                                    ) : (
                                        // Object with section heading + paragraphs
                                        <Box mb={3}>
                                            {Object.keys(item).map((key) => (
                                                <Box key={key} mb={2}>
                                                    <Typography
                                                        variant="h5"
                                                        sx={{
                                                            color: "#030366",
                                                            fontWeight: "bold",
                                                            mb: 1,
                                                        }}
                                                    >
                                                        {key}
                                                    </Typography>
                                                    {item[key].map((subItem, subIndex) => (
                                                        <Typography
                                                            key={subIndex}
                                                            variant="body1"
                                                            sx={{
                                                                mb: 1,
                                                                textAlign: "justify",
                                                                fontSize: "18px",
                                                            }}
                                                        >
                                                            {subItem}
                                                        </Typography>
                                                    ))}
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            ))}
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default B2BMobileApps;
